import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import useDraggable from './useDraggable';
export default function SVGDraggable(props) {
    const { children, initialPosition = { x: 0, y: 0 }, width, height, onStart, onMove, onEnd, parentElement, dragHandleClassName, } = props;
    const { position: { value: { x, y }, action, }, onMouseDown, } = useDraggable({
        position: initialPosition,
        parentElement,
        dragHandleClassName,
    });
    useEffect(() => {
        const position = {
            x,
            y,
        };
        switch (action) {
            case 'start':
                onStart?.(position);
                break;
            case 'move':
                onMove?.(position);
                break;
            case 'end':
                onEnd?.(position);
                break;
            default:
                break;
        }
    }, [action, onEnd, onMove, onStart, x, y]);
    return (_jsx("g", { style: {
            transform: `translate(${x}px,${y}px)`,
        }, onMouseDown: onMouseDown, children: typeof children === 'function' ? children(width, height) : children }));
}
